import { render, staticRenderFns } from "./upgrade_team.vue?vue&type=template&id=64226f30&scoped=true"
import script from "./upgrade_team.vue?vue&type=script&lang=js"
export * from "./upgrade_team.vue?vue&type=script&lang=js"
import style0 from "./upgrade_team.vue?vue&type=style&index=0&id=64226f30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64226f30",
  null
  
)

export default component.exports